import { createInternalAuthLoggedInFetch } from '@own-up/widgets-react/modules/auth/internal/create-internal-auth-logged-in-fetch';

const doFetch = createInternalAuthLoggedInFetch({});
export const loggedInFetch = (info: RequestInfo, headers?: RequestInit) =>
  doFetch(info, headers || { headers: {} }, async (r) => {
    // Send the user to the session expired page to trigger a relog
    window.location.href = '/auth?redirectUrl=' + encodeURIComponent(window.location.href);
    return r;
  });
